<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="accessLoader" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full' && user_type=='cdm'">
	<div class="card-header bg-primary">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-3">
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-checkbox style="width: 100%;" color="primary" id="credit_notes" formControlName="credit_notes">
						Credit Notes
					</mat-checkbox>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<custom-input formControlName="inv_no" [id]="'inv_no'" [label]="'Invoice No.'"
						[required]="f.inv_no.hasValidator(requiredValidator)" [hasError]="showError('inv_no')"
						[errors]="f.inv_no.errors" [customError]="customError?.inv_no"></custom-input>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>Invoice Date(DD-MM-YYYY)</mat-label>
						<input matInput [matDatepicker]="invoice_date_picker" formControlName="inv_date">
						<mat-datepicker-toggle matIconSuffix [for]="invoice_date_picker"></mat-datepicker-toggle>
						<mat-datepicker #invoice_date_picker></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('inv_date')" class="text-danger">
						<span *ngIf="f.inv_date.errors?.required">
							Required
						</span>
						<span *ngIf="f.inv_date.errors?.incorrect">
							{{customError.inv_date}}
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<custom-input formControlName="amount" [id]="'amount'" [label]="'Amount'"
						[required]="f.amount.hasValidator(requiredValidator)" [hasError]="showError('amount')"
						[errors]="f.amount.errors" [customError]="customError?.amount"></custom-input>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>Currency</mat-label>
						<mat-select formControlName="currency">
							<mat-option [value]="null">--Select--</mat-option>
							@for (curr of currencyList; track curr) {
							<mat-option [value]="curr.name">{{curr.name}}</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<p *ngIf="showError('currency')" class="text-danger">
						<span *ngIf="f.currency.errors?.required">
							Required
						</span>
						<span *ngIf="f.currency.errors?.incorrect">
							{{customError.currency}}
						</span>
					</p>
				</div>
				<!-- <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
					<br />
					<ng-toggle formControlName="is_paid" [color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
						[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
						[switchColor]="{checked: '#198754',unchecked: '#dc3545'}"
						[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="90"></ng-toggle>
				</div> -->
			</div>
			<div class="row mb-3">
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>Paid Date(DD-MM-YYYY)</mat-label>
						<input matInput [matDatepicker]="paid_date_picker" formControlName="paid_date">
						<mat-datepicker-toggle matIconSuffix [for]="paid_date_picker"></mat-datepicker-toggle>
						<mat-datepicker #paid_date_picker></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('paid_date')" class="text-danger">
						<span *ngIf="f.paid_date.errors?.incorrect">
							{{customError.paid_date}}
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="companyList" bindLabel="name" bindValue="id" [clearable]="true"
						id="company_master_id" formControlName="company_master_id" name="company_master_id"
						placeholder="Company*" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('company_master_id')" class="text-danger">
						<span *ngIf="f.company_master_id.errors?.required">
							Required
						</span>
						<span *ngIf="f.company_master_id.errors?.incorrect">
							{{customError.company_master_id}}
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="servicesList" bindLabel="service_name" bindValue="id"
						[clearable]="true" id="services_master_id" formControlName="services_master_id"
						placeholder="Service*" appearance="outline">
					</ng-select>
					<p *ngIf="showError('services_master_id')" class="text-danger">
						<span *ngIf="f.services_master_id.errors?.required">
							Required
						</span>
						<span *ngIf="f.services_master_id.errors?.incorrect">
							{{customError.services_master_id}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<ngx-file-drop dropZoneLabel="Drop file here" browseBtnLabel="Browse file" [multiple]="false"
						(onFileDrop)="uploadFile($event)" [disabled]="fileUploaderLoader">
						<ng-template multiple="false" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
							<div style="text-align: center;">
								<button type="button" class="btn btn-outline-primary btn-sm"
									(click)="openFileSelector()" [disabled]="fileUploaderLoader">
									<fa-icon *ngIf="fileUploaderLoader" [icon]="['fas', 'spinner']"
										animation="spin"></fa-icon>
									Drop Or Browse file
								</button>
							</div>
						</ng-template>
					</ngx-file-drop>
				</div>
				<div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
					<a class="btn btn-sm btn-primary" *ngIf="f.invoice_upload.value"
						href="{{File_Storage_URL}}{{f.invoice_upload.value}}" target="_blank">
						View File
					</a>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/invoices']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full' || user_type!='cdm'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>